import { render } from "./BusinessAddressAdditionForm.vue?vue&type=template&id=7b67296e&ts=true"
import script from "./BusinessAddressAdditionForm.vue?vue&type=script&lang=ts"
export * from "./BusinessAddressAdditionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__